import { CONTENT_CLASSES } from '../constants/classNames';

/**
 * A short quiz. Each answer stays folded away until the reader opens it.
 */
export default function QuizList({ quiz }) {
  return (
    <section className={CONTENT_CLASSES.section}>
      <h2 className={CONTENT_CLASSES.sectionTitle}>Quick quiz</h2>
      <ol className={CONTENT_CLASSES.quiz}>
        {quiz.map(({ question, answer }) => (
          <li key={question} className={CONTENT_CLASSES.quizItem}>
            <details>
              <summary className={CONTENT_CLASSES.quizQuestion}>{question}</summary>
              <p className={CONTENT_CLASSES.quizAnswer}>{answer}</p>
            </details>
          </li>
        ))}
      </ol>
    </section>
  );
}
